module.exports = __webpack_public_path__ + "static/contact-header-img-3005b204e0ff8efc162d877c0e653861.png";